<!-- resources/js/App.vue -->
<template>
    <div class="relative min-h-screen bg-white text-gray-900 font-sans">
        <header class="flex items-center shadow-md bg-[#800000] text-white">
            <img
                src="/img/pwa/icon-192.png"
                alt="Logo"
                class="h-16 w-16 object-cover mr-4"
            />
            <h1 class="text-xl font-semibold p-4">
                {{ appName }}
            </h1>
        </header>


        <main class="p-2 pb-24 z-10">
            <router-view v-slot="{ Component }">
                <component :is="Component" @update:footerVisible="footerVisible = $event" @set-blink-map="onSetBlink" />
            </router-view>
        </main>

        <footer v-if="footerVisible" class="fixed z-1000 bottom-0 left-0 px-4 py-1 text-center text-sm bg-[#800000] text-white border-t w-full shadow-inner">
            <NavBar :blinkMap="blinkMap"/>
            <div class="absolute bottom-0 right-0 text-[8px] text-gray-300 opacity-30 self-end p-2">Build {{ BUILD_DATE }}</div>
        </footer>
    </div>

</template>

<script setup lang="ts">
import { ref } from 'vue'
import NavBar from '@/components/NavBar.vue'
const BUILD_DATE = __BUILD_DATE__
const appName = import.meta.env.VITE_APP_NAME
const footerVisible = ref(true)

import { useScoreStore } from '@/stores/score'

const scoreStore = useScoreStore()
// si le timer était déjà lancé, on le redémarre
if (scoreStore.started) {
    scoreStore.startTimer()
}

const blinkMap = ref(false)
function onSetBlink(val: boolean) {
    blinkMap.value = val
}
</script>

<style>
body {
    margin: 0;
    padding: 0;
    font-family: 'Helvetica Neue', sans-serif;
}
</style>
